import { toast } from 'react-toastify';
import { atom } from 'recoil';
import * as XLSX from 'xlsx';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const protocol = window.location.protocol;
const hostname = window.location.hostname;
const host = window.location.host;
let apiUrl = `${protocol}//${host}/`;
if (hostname === 'localhost') {
    apiUrl = 'http://localhost:5102/';
} else {
    apiUrl = 'https://hrms.viva-holidays.co.in/';
}
export const API_SERVER = apiUrl;
//export const API_SERVER = 'http://localhost:5102/';
////export const API_SERVER = 'http://hrms.viva-holidays.co.in/';

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "1",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}

export const AutoCompleteList = (Type, Token, preFix, ContextKey, ContextKey2, cb) => {
    fetch(`${API_SERVER}api/AutoComplete/GetAutoComplete`, {
        method: 'POST',
        body: JSON.stringify({ ...Token, Type, preFix, ContextKey, ContextKey2 }),
        headers: {
            "Content-Type": "application/json"
        }
    }).then((res) => res.json())
        .then((res) => {
            cb({ res })
        })
        .catch((err) => (err))
}

function isNumeric(value) {
    return /^-?\d*\.?\d+$/.test(value);
}

export const handleDownloadExcel = async (handleApiUrl, requestData, FileName, sessionExpired) => {
    const apiUrl = handleApiUrl;
    const requestHeaders = { 'Content-Type': 'application/json' };

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(requestData),
            headers: requestHeaders,
        });
        const res = await response.json();

        if (res.Status === "SUCCESS") {
            // Initialize ExcelJS workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(FileName);

            // Set headers and data in worksheet
            worksheet.addRow(res.HeadersValue); // Header row
            res.Data.forEach(record => {
                const rowData = res.HeadersKey.map(key => isNumeric(record[key]) ? parseFloat(record[key]) : record[key]);
                worksheet.addRow(rowData);
            });

            // Style the header row
            const headerRow = worksheet.getRow(1);
            headerRow.eachCell(cell => {
                cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4472C4" } };
                //cell.alignment = { horizontal: "center" };
            });

            // Style data rows
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber !== 1) { // Skip header row
                    row.eachCell(cell => {
                        cell.alignment = isNumeric(cell) ? { horizontal: "right" } : { horizontal: "left" };
                        cell.border = {
                            top: { style: "thin" },
                            left: { style: "thin" },
                            bottom: { style: "thin" },
                            right: { style: "thin" },
                        };
                    });
                }
            });

            // Auto-width columns based on content
            worksheet.columns.forEach(column => {
                let maxLength = 5;
                column.eachCell(cell => {
                    if (cell.value) {
                        maxLength = Math.max(maxLength, cell.value.toString().length);
                    }
                });
                column.width = maxLength + 2; // Add some padding
            });

            // Generate and download the Excel file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, `${FileName}.xlsx`);
        } else if (res.Status === 'ERROR') {
            console.error("Error:", res.Message);
            toast.error(res.Message);
        } else if (res.Status === "EXPIRED") {
            toast.error(res.Message);
            sessionExpired();
        } else if (res.Status === "UNAUTHORIZED") {
            toast.error(res.Message);
        }
    } catch (err) {
        toast.error(err.message, { position: 'top-center' });
    }
};

//export const handleDownloadExcel = async (handleApiUrl, requestData, FileName, sessionExpired) => {
//    const apiUrl = handleApiUrl;
//    const requestBody = requestData
//    const requestHeaders = {
//        'Content-Type': 'application/json',
//    };
//    try {
//        const response = await fetch(apiUrl, {
//            method: 'POST',
//            body: JSON.stringify(requestBody),
//            headers: requestHeaders,
//        });
//        const res = await response.json();
//        if (res.Status === "SUCCESS") {
//            const workbook = XLSX.utils.book_new();
//            let worksheet = XLSX.utils.aoa_to_sheet([
//                res?.HeadersValue
//                ,
//                ...res?.Data?.map((records) =>
//                    res.HeadersKey?.map((data, i) =>
//                        //records[data]
//                        isNumeric(records[data]) ? parseFloat(records[data]) : records[data]
//                        //typeof records[data] === 'string' ? parseFloat(records[data]) : records[data]
//                    )
//                ),
//            ]);
//            XLSX.utils.book_append_sheet(workbook, worksheet, FileName);
//            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//            const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
//            const url = window.URL.createObjectURL(data);
//            const link = document.createElement('a');
//            link.href = url;
//            link.setAttribute('contenttype', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//            link.setAttribute('download', `${FileName}.xlsx`);
//            document.body.appendChild(link);
//            link.click();
//            document.body.removeChild(link);
//            window.URL.revokeObjectURL(url);
//            return
//        } else if (res.Status === 'ERROR') {
//            console.log("Error")
//            toast.error(res.Message)
//            // NotificationSound(res.Status, res.Message)
//        } else if (res.Status === "EXPIRED") {
//            toast.error(res.Message)
//            sessionExpired()
//        } else if (res.Status === "UNAUTHORIZED") {
//            toast.error(res.Message);
//        }
//    } catch (err) {
//        toast.error(err.message, {
//            position: 'top-center',
//        });
//    }


//};

export const NotificationCount = atom({
    key: "notificationCount",
    default: {
        pendingVerificationData: '',
        pendingConvertToEmployee: '',
        totalNotification: ''
    }

})

export const handleDownloadZip = async (handleApiUrl, requestData, FileName, sessionExpired) => {
    const apiUrl = handleApiUrl;
    const requestBody = requestData
    const requestHeaders = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res.Status === "SUCCESS") {        

            const byteCharacters = atob(res.ZipPath);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/zip' });

            // Create a link and set the URL using createObjectURL
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = FileName+".zip"; // Name of the file to be downloaded
            document.body.appendChild(link);
            // Trigger the download by programmatically clicking the link
            link.click();

            // Clean up by removing the link
            document.body.removeChild(link);

        } else if (res.Status === 'ERROR') {
            console.log("Error")
            toast.error(res.Message)
        } else if (res.Status === "EXPIRED") {
            toast.error(res.Message)
            sessionExpired()
        } else if (res.Status === "UNAUTHORIZED") {
            toast.error(res.Message);
        }
    } catch (err) {
        toast.error(err.message, {
            position: 'top-center',
        });
    }
};